const cutWorldFromURL = (url = '', world: string): string =>
    url === `/${world}` ? '/' : url.replace(`/${world}/`, '/');

export default cutWorldFromURL;
